export default {
  title: 'Hoida liiketoimintaasi mistä tahansa',
  description: 'Kirjaudu olemassa olevalle tilillesi.',
  form: {
    email: {
      label: 'Sähköposti',
      placeholder: 'Anna sähköposti',
    },
    password: {
      label: 'Salasana',
      placeholder: 'Anna salasana',
    },
    error_messages: {
      missing_info: 'Puuttuvat tiedot',
      wrong_credentials: 'Väärä sähköposti tai salasana',
    },
  },
  buttons: {
    login: 'Kirjaudu sisään',
    forgot_password: 'Unohditko salasanasi',
  },
  white_label: {
    title: 'Kirjaudu hallintapaneeliin',
    form: {
      email: {
        label: 'Sähköpostiosoite',
        placeholder: 'you@restaurant.com',
      },
      password: {
        label: 'Salasana',
        placeholder: 'Anna salasanasi',
      },
    },
    buttons: {
      login: 'Kirjaudu sisään',
    },
    intro: {
      eyebrow: 'Tilaustenhallinta',
      headline: 'Hoida ravintolaasi mistä tahansa.',
      description: 'Tilaukset, ruokalistat, aukioloajat ja maksut — kaikki yhdessä paikassa.',
      features: {
        live: {
          title: 'Live',
          subtitle: 'tilauksen seuranta',
        },
        instant: {
          title: 'Välitön',
          subtitle: 'ruokalistan muutokset',
        },
        any_device: {
          title: 'Mikä tahansa laite',
          subtitle: 'puhelin tai tabletti',
        },
      },
    },
  },
};
